export default "__VITE_PUBLIC_ASSET__f2b6590c__"